import { useNotification } from "@design-lab/shared/ui/notification";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import api from "common/utils/api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import type { userPreferences } from "common/utils/models";

// API function to update user preferences for mockup
const updateUserPreferencesMockup = async (
  params: userPreferences.updateMockup.Request
): Promise<userPreferences.updateMockup.Response> => {
  const data = await api.userPreferences.updateMockup(params);
  return objNamesToCamelCase(data);
};

export function useUpdateUserPreferencesMockup() {
  const { error: notifyError } = useNotification();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUserPreferencesMockup,
    onSuccess: () => {
      // Invalidate and refetch all product queries to get fresh data from the server
      queryClient.invalidateQueries({
        predicate: query => {
          const key = query.queryKey;
          // Invalidate product queries with structure: ["product", productId, sampleMode] or ["product", productId, sampleMode, "design_lab"]
          return (
            Array.isArray(key) &&
            (key.length === 3 || key.length === 4) &&
            key[0] === "product" &&
            typeof key[1] === "string" &&
            (key[2] === "regular" || key[2] === "sample") &&
            (key.length === 3 || key[3] === "design_lab")
          );
        }
      });
    },
    onError: () => {
      notifyError({
        title: "Model Selection Failed",
        description: "Failed to save model selection. Please try again."
      });
    }
  });
}
